module.exports = __webpack_public_path__ + "img/icon-copy.ad871574.svg";